import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-vx",
  "use": "icon-vx-usage",
  "viewBox": "0 0 20 16.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16.3\" id=\"icon-vx\"><title>资源 6</title><g id=\"icon-vx_图层_2\" data-name=\"图层 2\"><g id=\"icon-vx_图层_1-2\" data-name=\"图层 1\"><path d=\"M13.5,4.9h.7c-.6-2.9-3.6-5-7.1-5S0,2.7,0,6a5.8,5.8,0,0,0,2.8,4.8l-.7,2.1,2.5-1.2a10.7,10.7,0,0,0,2.5.3h.6a7.7,7.7,0,0,1-.2-1.5,5.8,5.8,0,0,1,6-5.6ZM9.7,3a.8.8,0,0,1,.9.9.8.8,0,0,1-.9.9,1,1,0,0,1-1-.9,1,1,0,0,1,1-.9ZM4.8,4.8a1,1,0,0,1-1.1-.9A1,1,0,0,1,4.8,3a.9.9,0,1,1,0,1.8ZM20,10.4c0-2.8-2.8-5.1-6-5.1S8,7.6,8,10.4s2.6,5.2,6,5.2a7.8,7.8,0,0,0,2.1-.4l2,1.1-.6-1.8A5.4,5.4,0,0,0,20,10.4Zm-8-.8a.8.8,0,0,1-.7-.7.9.9,0,0,1,.7-.8.8.8,0,0,1,.9.8.8.8,0,0,1-.9.7Zm3.9,0a.8.8,0,0,1-.7-.7.9.9,0,0,1,.7-.8.8.8,0,0,1,.9.8.8.8,0,0,1-.9.7Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/vx.svg
// module id = t4pt
// module chunks = 60